/* global __DEVTOOLS__ */
import * as PropTypes from "prop-types";
import React, { Component } from 'react';
import {Provider} from 'react-redux'
import ReduxToastr from 'react-redux-toastr'
import {contextMenu} from "@mc/mc-legacy";
import {BrowserRouter} from "react-router-dom";
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import Routes from "./Routes";

/**
 * Root pro aplikaci.
 */
export default class Root extends Component {

    static propTypes = {
        store: PropTypes.object.isRequired
    };

    render() {
        const {store} = this.props;
        return (
            <Provider store={store} key="provider">
                <div className="root-container">
                    <BrowserRouter key="router" basename={serverContextPath}>
                        <Routes />
                    </BrowserRouter>
                    <ReduxToastr />
                    <contextMenu.ContextMenuContainer />
                </div>
            </Provider>
        )
    }
}
